// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import colors from '../../../../../../styles/themes/TCP/colors';

export default css`
  &.sth-main {
    height: ${(props) =>
      props.fromStoreDetailPage ? props.theme.spacing.ELEM_SPACING.XXL : 'fit-content'};
    ${(props) => (props.fromStoreDetailPage ? ` width: 200px;` : ``)};

    border: 1px solid #3d6a8e;
    padding: 12px, 8px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;
    color: ${colors.TEXT.DARKERGRAY};

    .icon-label-container {
      display: flex;
      white-space: nowrap;
      ${(props) =>
        props.fromStoreDetailPage
          ? `justify-content: center; font-family: ${props.theme.fonts.secondaryFontExtraBoldFamily};`
          : ``};
    }
    .shop-this-store-new-icon {
      margin-right: 8px;
      margin-top: 1px;
    }
    ${(props) =>
      props.viewMapIconPresent
        ? `@media ${props.theme.mediaQuery.medium} {
      margin-bottom: 12px;
    }`
        : ``};
  }

  &.cta-left {
    margin: auto 0 auto 16px;
  }
  &.cta-right {
    margin: auto 16px auto 0;
  }
`;
